<template>
  <div class="page">
    <section class="content-section secondary">
      <div class="section-title">
          <!-- <div class="section-title-line"></div> -->
          <h1 style="color:white">GECHICHTE DES UNTERNEHMENS</h1>
          <!-- <div class="section-title-line"></div> -->
      </div>
      <section class="container rows">
        <div class="row full">
          <div class="history-year column quarter">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/gruendung.jpg"></div>
            <div class="column-title">1965</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Die Firmengeschichte begann mit Gründung eines Steinmetzbetriebes namens Marmor Kunze im Jahr 1965 durch Josef Kunze. Der damalige Firmensitz befand sich noch auf der Druckerstraße 15 in Mönchengladbach Rheydt. </div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/ausstellung.jpg"></div>
            <div class="column-title">1996</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Nach zweijährigem Besuch der Steinmetzfachschule in Mayen (Eifel) und Ausbildung zum Steintechniker, Steinmetz- und Bildhauermeister übernahm der Sohn Frank Kunze den Betrieb im Jahr 1996. Gleichzeitig wurde auch das neue Firmengelände auf dem Marie-Bernays-Ring 17b bezogen. Das über 2000m² große Betriebsgelände bietet auch heute noch ausreichend Platz für modernste Naturstein-Fertigungsanlagen und unserer Naturstein-Ausstellung.</div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><img src="https://www.marmor-kunze.de/static/images/geselleneinstellung.jpg"></div>
            <div class="column-title">1997</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Mit dem größeren Betriebsgelände und der stetig steigenden Auftragslage, war es auch an der Zeit einen weiteren Steinmetzgesellen aufzunehmen, der auch heute noch fest zu unserem Team gehört.</div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><router-link to="kontakt"><img src="https://www.marmor-kunze.de/static/images/cnc.jpg"></router-link></div>
            <div class="column-title">2007</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Im Jahr 2007 wurde unsere Werkstatt um modernste Technik erweitert! Das erste CNC – Bearbeitungszentrum wurde in Betrieb genommen!</div>
          </div>
        </div>
        <div class="row full">
          <div class="history-year column quarter reverse">
            <div class="column-image"><router-link to="kontakt"><img src="https://www.marmor-kunze.de/static/images/geselleneinstellung2.jpg"></router-link></div>
            <div class="column-title">2018</div>
          </div>
          <div class="history-info column three-quarter">
            <div class="info-text">Im Jahr 2018 wurde unser Team erweitert und ein neuer Auszubildender aufgenommen!</div>
          </div>
        </div>
      </section>
      </section>
  </div>
</template>

<script>
export default {
  name: 'UeberUns',
  metaInfo: {
    title: "Geschichte des Unternehmens",
    meta:[
      { vmid: 'description', name: 'description', content: "Die Firmengeschichte begann mit Gründung eines Steinmetzbetriebes namens Marmor Kunze im Jahr 1965 durch Josef Kunze."},
      { vmid: 'keywords', name: 'keywords', content: "Firmengeschichte, Gründung, Steinmetzbetrieb, Marmor Kunze, Naturstein Mönchengladbach, Naturstein, Naturstein-Ausstellung"},
    ],
    links: [ {rel: 'canonical', href: 'https://www.marmor-kunze.de/ueber-uns'} ]
  },
}
</script>
j
<style>
</style>



// WEBPACK FOOTER //
// src/components/views/UeberUns.vue